import React from "react"
import {useModal} from "../AppContext"
import {ButtonClose} from "./Button"
import style from "./Modal.css"

export const Modal = ({type, tile = '', children, userStyle = {}, bright = false}) => {
    const modal = useModal()
    const stopPropagation = event => event.stopPropagation()
    const className = bright
        ? (modal.isTop(type) ? style.containerBrightTop : style.containerBright)
        : (modal.isTop(type) ? style.containerTop : style.container)

    const onClose = () => {
        modal.close()
    }

    if(!modal.isTop(type)) {
        userStyle = {...userStyle, opacity: .25}
    }


    return <div className={className} onClick={onClose} style={{zIndex: modal.getZIndex(type)}}>
        <div onClick={stopPropagation} className={style.layout} style={userStyle}>
            <div className={style.head}>
                <div>{tile}</div>
                <ButtonClose onClick={onClose}/>
            </div>
            <div className={style.content}>
                {children}
            </div>
        </div>
    </div>
}
